(() => {
  const initialized = window.VenaSupportFaqInitialized || new WeakSet();
  window.VenaSupportFaqInitialized = initialized;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function answerWrap(drawer) {
    return drawer.querySelector('.vena-support-faq__answer-wrap');
  }

  function stop(drawer) {
    const wrap = answerWrap(drawer);
    if (!wrap) return;
    wrap.getAnimations().forEach((animation) => animation.cancel());
    wrap.style.height = '';
    drawer.classList.remove('is-opening', 'is-closing');
  }

  function close(drawer, immediate = false) {
    if (!drawer.open) return;
    const wrap = answerWrap(drawer);
    if (!wrap || immediate || reducedMotion.matches) {
      drawer.open = false;
      stop(drawer);
      return;
    }
    stop(drawer);
    drawer.classList.add('is-closing');
    wrap.style.height = `${wrap.offsetHeight}px`;
    requestAnimationFrame(() => { wrap.style.height = '0px'; });
    const end = (event) => {
      if (event.target !== wrap || event.propertyName !== 'height') return;
      wrap.removeEventListener('transitionend', end);
      drawer.open = false;
      wrap.style.height = '';
      drawer.classList.remove('is-closing');
    };
    wrap.addEventListener('transitionend', end);
  }

  function open(drawer, immediate = false) {
    if (drawer.open && !drawer.classList.contains('is-closing')) return;
    const wrap = answerWrap(drawer);
    if (!wrap || immediate || reducedMotion.matches) {
      drawer.open = true;
      stop(drawer);
      return;
    }
    stop(drawer);
    drawer.open = true;
    drawer.classList.add('is-opening');
    wrap.style.height = '0px';
    requestAnimationFrame(() => { wrap.style.height = `${wrap.scrollHeight}px`; });
    const end = (event) => {
      if (event.target !== wrap || event.propertyName !== 'height') return;
      wrap.removeEventListener('transitionend', end);
      wrap.style.height = '';
      drawer.classList.remove('is-opening');
    };
    wrap.addEventListener('transitionend', end);
  }

  function init(section) {
    if (initialized.has(section)) return;
    initialized.add(section);

    const drawers = Array.from(section.querySelectorAll('[data-vena-faq-category]'));
    const desktopButtons = Array.from(section.querySelectorAll('[data-vena-topic]'));
    const mobileButtons = Array.from(section.querySelectorAll('[data-vena-mobile-topic]'));
    const mobileMenu = section.querySelector('[data-vena-mobile-topics]');
    const categoryHeading = section.querySelector('[data-vena-category-heading]');
    if (!drawers.length) return;

    function labelFor(category) {
      const button = desktopButtons.find((item) => item.dataset.venaTopic === category);
      return button ? button.textContent.trim() : category;
    }

    function showCategory(category) {
      drawers.forEach((drawer) => {
        const visible = drawer.dataset.venaFaqCategory === category;
        drawer.classList.toggle('is-visible', visible);
        drawer.open = false;
        stop(drawer);
      });
      desktopButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.venaTopic === category));
      mobileButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.venaMobileTopic === category));
      if (categoryHeading) categoryHeading.textContent = labelFor(category);
    }

    desktopButtons.forEach((button) => button.addEventListener('click', () => showCategory(button.dataset.venaTopic)));
    mobileButtons.forEach((button) => {
      button.addEventListener('click', () => {
        showCategory(button.dataset.venaMobileTopic);
        if (mobileMenu) mobileMenu.open = false;
      });
    });

    drawers.forEach((drawer) => {
      const summary = drawer.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (drawer.open && !drawer.classList.contains('is-closing')) {
          close(drawer);
          return;
        }
        drawers.forEach((other) => {
          if (other !== drawer && other.classList.contains('is-visible')) close(other);
        });
        open(drawer);
      });
    });

    showCategory('shipping');
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-vena-support-faq]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();